import TYPES from '@/modules/shared/types';

// Domain
import { CreateKuspitWithdrawalRepository } from '../../domain/repository/create-kuspit-withdrawal-repository';
import { CreateKuspitWithdrawalDto } from '../../domain/dtos/create-kuspit-withdrawal-dto';
import { ResultKuspitWithdrawalEntity } from '../../domain/entities/result-kuspit-withdrawal-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class CreateKuspitWithdrawalHttpRepository
implements CreateKuspitWithdrawalRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/kuspit/withdrawal/`;

  create(kuspit_withdrawal: CreateKuspitWithdrawalDto): Promise<ResultKuspitWithdrawalEntity> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(
        this.endpoint,
        'POST',
        kuspit_withdrawal,
      )
        .then((response) => {
          response.json()
            .then(({ success, message, data }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
